import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import Icon from '../../Icons/Icon.js';

var AddIcon = Icon(jsxs(Fragment, { children: [jsx("path", { d: "M0 0h24v24H0z", fill: "none" }), jsx("path", { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" })] }), '0 0 24 24', 'AddIcon');

export { AddIcon as default };
